module.exports = __webpack_public_path__ + "static/media/google.da01ff13.png";